import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { color, mediaQuery } = baseVariables;

export const StyledEventBanner = styled.div`
  .event-banner {
    padding: ${toRem(32)};
    text-align: center;
    .event-title {
      margin: 0 auto;
      font-size: ${toRem(30)};
      line-height: ${toRem(36)};
      word-break: break-word;
    }
    .event-description {
      font-size: ${toRem(14)};
      color: ${color.neutral40};
      margin: ${toRem(16)} auto 0 auto;
      padding-bottom: ${toRem(1)};
      padding-right: ${toRem(4)};
      padding-left: ${toRem(4)};
      word-wrap: break-word;
    }
    .custom-links {
      margin: ${toRem(16)} auto ${toRem(10)} auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      a {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow-wrap: anywhere;
        &:nth-child(2) {
          margin-top: ${toRem(24)};
        }
      }
    }
  }
  .m-link-action {
    font-size: ${toRem(13)};
    background: none;
  }

  &.with-media {
    .media-container {
      width: 100%;
      .fullbleed-carousel {
        .glide__slides {
          background-color: ${color.neutral10};
          .glide__slide {
            text-align: center;
            margin-top: auto;
            margin-bottom: auto;
            .carousel-image {
              height: auto;
              max-height: ${toRem(536)};
              object-fit: contain;
            }
          }
        }
      }
    }
  }

  @media ${mediaQuery.md} {
    .event-banner {
      padding: ${toRem(40)} ${toRem(32)};
      .event-title {
        max-width: ${toRem(460)};
      }
      .event-description {
        padding-bottom: ${toRem(8)};
        max-width: ${toRem(584)};
        p {
          margin-bottom: ${toRem(8)};
        }
        &.custom-scrollbar {
          ::-webkit-scrollbar-thumb {
            background-clip: padding-box;
            border: ${toRem(4)} solid rgba(0, 0, 0, 0);
            border-radius: ${toRem(10)};
            background-color: rgb(187 182 182);
          }
          ::-webkit-scrollbar {
            width: ${toRem(14)};
          }
          ::-webkit-scrollbar-track {
            background-color: transparent;
          }
        }
      }
      .custom-links {
        flex-direction: row;
        max-width: ${toRem(460)};
        gap: ${toRem(16)};
        a {
          flex: 1;
          height: auto;
          min-height: ${toRem(50)};
          max-width: 50%;
          padding: 0 ${toRem(24)};
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: inline-block;
          vertical-align: middle;
          line-height: ${toRem(50)};
          &:nth-child(2) {
            margin-top: 0;
          }
        }
      }
    }
    &.map-view-banner {
      display: grid;
      align-items: normal;
      .event-banner {
        display: grid;
        align-items: center;
        grid-template-columns: 70% 30%;
        text-align: left;
        padding: ${toRem(24)};
        .event-title {
          font-size: ${toRem(22)};
          line-height: ${toRem(26)};
          color: ${color.base10};
          text-align: left;
          margin: 0;
          max-width: 100%;
        }
        .event-description {
          font-size: ${toRem(14)};
          line-height: ${toRem(20)};
          text-align: left;
          margin-left: 0;
          padding-bottom: 0;
          padding-right: ${toRem(24)};
          margin-top: ${toRem(8)};
          max-width: 100%;
          > div > div > * {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding-right: ${toRem(4)};
            padding-left: ${toRem(4)};
          }
          &.overflow {
            > div > div > *:not(:first-child) {
              display: none;
            }
          }

          &.expanded {
            > div > div > * {
              white-space: normal;
            }
            > div > div > *:not(:first-child) {
              display: block;
            }
          }
        }
        .custom-links {
          a {
            text-align: center;
          }
        }
      }
      &.with-media {
        &.map-view-banner {
          grid-template-columns: 15% 85%;
          .media-container {
            .fullbleed-carousel {
              .glide__slides {
                height: ${toRem(150)};
                .glide__slide {
                  .carousel-image {
                    max-height: 100%;
                  }
                }
              }
            }
          }
        }
      }
      &:not(.with-media) {
        &.map-view-banner {
          display: block;
          .event-banner {
            max-width: 100%;
          }
        }
      }
    }
    .m-link-action {
      margin-bottom: ${toRem(10)};
    }
  }

  @media ${mediaQuery.lg} {
    &.with-media {
      display: grid;
      align-items: center;
      grid-template-columns: 55% 45%;
      &.map-view-banner {
        align-items: start;
      }
      .fullbleed-carousel {
        .glide__slides {
          height: ${toRem(536)};
          .glide__slide {
            height: auto;
          }
        }
      }
      .event-banner {
        padding: ${toRem(10)} ${toRem(40)} ${toRem(4)} ${toRem(40)};
        .custom-links {
          padding: 0;
        }
      }
    }
    &:not(.with-media) {
      text-align: center;
      .event-banner {
        max-width: ${toRem(744)};
        margin: auto;
      }
    }
    .event-description {
      max-height: ${toRem(170)};
      overflow-y: auto;
    }
  }

  @media ${mediaQuery.xl} {
    .event-description {
      max-height: ${toRem(250)};
    }

    &.with-media {
      &:not(.map-view-banner) {
        .media-container {
          .fullbleed-carousel {
            .glide__slides {
              .glide__slide {
                .carousel-image {
                  width: auto;
                }
              }
            }
          }
        }
      }
    }
  }
`;
